import React, { useState, createContext } from 'react';
import { Helmet } from 'react-helmet';

import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import CssBaseline from '@mui/material/CssBaseline';
import Layout from './Layout';

import { UtilisateurCourantContext } from "context/UtilisateurCourantContext"

import LoginPage from './Screens/LoginPage';
import DashboardPage from './Screens/DashboardPage';
import ReclamationPage from './Screens/ReclamationPage';
import ReclamationsPage from './Screens/ReclamationsPage';
import AdministrationPage from './Screens/AdministrationPage';
import InformationsPage from './Screens/InformationsPage';
import LitigeRedirect from './Screens/LitigeRedirect';
import Page404 from './Screens/Page404';
import PageTest from './Screens/PageTest';

import AdministrationPreparationLogistiquePhoto from './Screens/AdministrationPage/PreparationLogistiquePhoto';
import UpdateNotification, { UPDATE_RELOAD_PENDING_KEY } from './UpdateNotification';

// Si l'application vient d'être rechargée suite à une nouvelle version, on force la
// déconnexion afin que l'utilisateur se reconnecte et obtienne un token à jour.
// Doit s'exécuter au chargement du module, avant la lecture de l'utilisateur courant.
if (localStorage.getItem(UPDATE_RELOAD_PENDING_KEY)) {
    localStorage.removeItem(UPDATE_RELOAD_PENDING_KEY);
    localStorage.removeItem('utilisateur');
}


// Voir pour recréér un composant PrivateRoute
function RequireAuth({ children }) {
    let location = useLocation();

    if (!localStorage.getItem('utilisateur')) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

const CurrentUserContext = createContext(null);

// On récupère l'utilisateur du localstorage
let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

export default function App() {
    
    const [utilisateur, setUtilisateur] = useState(utilisateurCourant);

    return (
        <React.StrictMode>
            <Helmet defaultTitle="Portail Après-Vente" titleTemplate="%s - Portail Après-Vente" />
            <CssBaseline />
            <UpdateNotification />

            <UtilisateurCourantContext.Provider value={{utilisateur, setUtilisateur}}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Layout />}>

                            <Route exact path="/login" element={<LoginPage />} />

                            <Route exact path="/" element={<RequireAuth> <DashboardPage /> </RequireAuth>} />

                            <Route exact path="/reclamations" element={<RequireAuth> <ReclamationsPage /> </RequireAuth>} />
                            <Route exact path="/reclamations/:id" element={<RequireAuth> <ReclamationPage /> </RequireAuth>} />
                            <Route exact path="/litiges/:cle" element={<RequireAuth> <LitigeRedirect /> </RequireAuth>} />

                            <Route exact path="/informations" element={<RequireAuth> <InformationsPage /> </RequireAuth>} />
                            <Route exact path="/informations/:numeroPiece" element={<RequireAuth> <InformationsPage /> </RequireAuth>} />

                            <Route exact path="/administration" element={<RequireAuth> <AdministrationPage /> </RequireAuth>} />
                            <Route exact path="/administration/:component" element={<RequireAuth> <AdministrationPage /> </RequireAuth>} />
                            <Route exact path="/administration/:component/:id" element={<RequireAuth> <AdministrationPage /> </RequireAuth>} />
                            <Route exact path="/administration/:component/:id/:subcomponent" element={<RequireAuth> <AdministrationPage /> </RequireAuth>} />
                            <Route exact path="/administration/:component/:id/:subcomponent/:subid" element={<RequireAuth> <AdministrationPage /> </RequireAuth>} />

                            <Route exact path="/404" element={<Page404 />} />

                            <Route exact path="/theme" element={<PageTest />} />

                            <Route exact path="/photos" element={<AdministrationPreparationLogistiquePhoto />} />

                        </Route>
                    </Routes>
                </BrowserRouter>
            </UtilisateurCourantContext.Provider>
        </React.StrictMode>
    );
}